import { h, Component } from "preact";

import Search from "./Search";
import AdminPane from "./AdminPane";
import UserPane from "./UserPane";
import ProjectPane from "./ProjectPane";

class MegaMenu extends Component {
  constructor() {
    super();

    this.state = {};
    this.onFilterChange = this.onFilterChange.bind(this);
    this.loadEnvironment = this.loadEnvironment.bind(this);
  }

  loadEnvironment() {
    const { project } = this.props.projectContext;
    if (!project || this.state.environment || this.state.environmentLoading) {
      return false;
    }

    this.setState({
      environmentLoading: true
    });

    this.props.client
      .getEnvironment(project.id, "master")
      .then(environment => {
        const sshUrls = environment.getSshUrls();

        this.setState({
          environmentLoading: false,
          environment,
          routesLinks: environment.getRouteUrls(),
          sshLinks: Object.keys(sshUrls).map(key =>
            sshUrls[key].replace("ssh://", "ssh ")
          )
        });
      });
  }

  onFilterChange(filters) {
    if (!filters || !filters.length) {
      // The API as no limit
      return false;
    }
    this.setState({
      isProjectListLoading: true
    });
    this.props.client
      .getSubscriptions(filters, true)
      .then(subscriptions => {
        this.setState({
          subscriptions,
          isProjectListLoading: false
        });
      })
      .catch(() => this.setState({
        isProjectListLoading: false
      }));
  }

  render({ client, accountUrl, open, projectContext = {}, userContext = {}, adminLinks = [], currentUsername }, { isProjectListLoading }) {
    return (
      <div
        class={`user-widget__mega_menu ${open
          ? "user-widget__mega_menu--open"
          : "user-widget__mega_menu--close"}`}
      >
        <div class="user-widget__mega_menu__projects">
          <Search
            projects={this.state.subscriptions}
            isLoading={isProjectListLoading}
            onFilterChange={this.onFilterChange}
            accountUrl={accountUrl}
          />
        </div>
        <div class="user-widget__mega_menu__admin">
          {!!((projectContext.project && Object.keys(projectContext.project).length > 0) || (userContext.user && Object.keys(userContext.user).length > 0)) && <div class="user-widget__mega_menu__admin__context">
            <div>
              <div class="user-widget__mega_menu__admin--title">
                Current Info
              </div>
              <ProjectPane
                username={currentUsername}
                client={client}
                accountUrl={accountUrl}
                projectContext={projectContext}
                defaultOpen={projectContext.project}
              />
              <UserPane
                userContext={userContext}
                defaultOpen={!projectContext.project && userContext.user}
              />
            </div>
          </div>}
          <div class="user-widget__mega_menu__admin__links">
            <AdminPane adminLinks={adminLinks} />
          </div>
        </div>
      </div>
    );
  }
}

export default MegaMenu;



// WEBPACK FOOTER //
// ./src/MegaMenu.js